<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed, dark, color='primary')
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') ユーザー管理
  v-container(fluid)
    v-row(align='center', justify='center')
      v-simple-table(dense, class='user-table')
        template(v-slot:default)
          thead
            tr
              th アイコン
              th Email
              th 表示名
              th(colspan='1')
                span アクション
                v-btn(small, class='ma-1', color='test', @click='prepareToAdd()') ユーザー追加
          tbody
            tr(:class="{'odd': index % 2 == 1}", v-for="(item, index) in users", :key="item.aspNetId")
              td
                img(:src='getImageUrl(item)', class='user-image')
              td
                span {{item.email}}
              td
                span {{item.displayName}}
              td
                v-btn(x-small, @click='edit(item)', class="ma-1") 編集
                v-btn(x-small, @click='prepareToChangePassword(item)', class="ma-1") パスワード変更
                v-btn(x-small, @click='changePicture(item)', class="ma-1") 写真変更
    v-dialog(v-model='dialogEdit', max-width='800')
      v-card
        v-card-title
          v-row
            v-card(flat) 
              v-img(height='60', width="60", :src='getImageUrl(recordToEdit)', class='mr-4')
            v-card(flat) {{recordToEdit.displayName}} {{recordToEdit.lastName}} {{recordToEdit.firstName}} 
        v-card-text 
          v-card(flat)
            v-row(flat, class='d-flex')
              v-row
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='表示名', v-model='recordToEdit.displayName', dense)
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='苗字', v-model='recordToEdit.lastName', dense)
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='名前', v-model='recordToEdit.firstName', dense)
              v-row
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='Slack Id', v-model='recordToEdit.slackId', dense)
                v-card(max-width="200", flat, class="ml-2")
                  v-text-field(label='電話番号', v-model='recordToEdit.telephoneNumber', dense)
                v-card(max-width="100", flat, class="ml-2")
                  v-text-field(label='Rome EmpId', v-model='recordToEdit.migrationReference1', dense)
              v-row
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 1', v-model='recordToEdit.familyName1', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 2', v-model='recordToEdit.familyName2', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 3', v-model='recordToEdit.familyName3', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 4', v-model='recordToEdit.familyName4', dense)
                v-card(min-width="100", flat, class="ml-2")
                  v-text-field(label='家族 5', v-model='recordToEdit.familyName5', dense)
              v-row
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.hasSubUser", class="ma-4", label="サブユーザーあり")
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.isExporting", class="ma-4", label="エクセル出力")
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.ignoreTimesheet", class="ma-4", label="勤怠管理しない")
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.isAdmin", class="ma-4", label="管理者")
                v-card(min-width="200", flat, class="ml-2")
                  v-text-field(label='サブアカウント 識別子', v-model='recordToEdit.supplimentalName', dense)
                v-card(min-width="200", flat, class="ml-2")
                  v-select(:items='groups', item-text="name", item-value='calendarGroupId', v-model='recordToEdit.calendarGroupId', label='カレンダーグループ')
                v-card(min-width="200", flat, class="ml-2")
                  v-select(:items='users', item-text="displayName", item-value='userDetailId', v-model='recordToEdit.approvalManager', label='休暇等承認ユーザ')
                v-card(min-width="200", flat, class="ml-2")
                  v-select(:items='tenantTeamMembers', item-text="displayName", item-value='teamsUserId', v-model='recordToEdit.teamsUserId', label='Teamsユーザ')
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.userEmploymentIsActive", class="ma-4", label="アクティブに雇用している")
                v-card(min-width="100", flat, class="ml-2")
                  v-switch(v-model="recordToEdit.skipSlackAuth", class="ma-4", label="Slack認証スキップ")
          v-divider(class="my-2")
          v-card-subtitle 曜日別デフォルト勤怠区分
          v-simple-table(dense)
            template(v-slot:default)
              thead
                tr
                  th 曜日
                  th 午前
                  th 午後
              tbody
                tr(v-for="(dayName, dayIndex) in dayNames", :key="dayIndex")
                  td {{ dayName }}
                  td
                    v-select(:items='workTypesWithDefault', item-text="name", item-value='tenantWorkTypeId', v-model='scheduleAM[dayIndex]', dense, hide-details, class="schedule-select")
                  td
                    v-select(:items='workTypesWithDefault', item-text="name", item-value='tenantWorkTypeId', v-model='schedulePM[dayIndex]', dense, hide-details, class="schedule-select")
        v-card-actions
          v-spacer
          v-btn(text, @click='dialogEdit = false') キャンセル
          v-btn(text, @click='updateUser()') 保存
    v-dialog(v-model='addingDialog', max-width='800')
      v-card
        v-card-title ユーザー追加
        v-card-text 
          v-card(flat)
            v-row
              v-form(v-model='addFormValudated')
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='Email', v-model='addingObject.email', dense, :rules='emailRules')
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='パスワード', v-model='addingObject.password', dense, :rules='passwordRules')
            v-row
              v-radio-group(v-model="addingObject.role")
                v-radio(v-for='n in roleDef', :key='n', :label='n', :value='n')
        v-card-actions
          v-spacer
          v-btn(text, @click='addingDialog = false') キャンセル
          v-btn(text, @click='addUser()', :disabled='!addFormValudated') 追加
    v-dialog(v-model='changePasswordDialog', max-width='800')
      v-card
        v-card-title パスワード変更
        v-card-text 
          v-card(flat)
            v-row
              v-form(v-model='changePasswordFormValudated')
                v-card(max-width="150", flat, class="ml-2")
                  v-text-field(label='表示名', v-model='changePasswordObject.displayName', readonly, dense)
                v-card(max-width="350", flat, class="ml-2")
                  v-text-field(label='新パスワード', v-model='changePasswordObject.newPassword', dense, :rules='passwordRules')
        v-card-actions
          v-spacer
          v-btn(text, @click='changePasswordDialog = false') Cancel
          v-btn(text, @click='changePassword()', :disabled='!changePasswordFormValudated') Change Password
    v-dialog(v-model='dialogPicture')
      v-card
        v-card-title 
        v-card-text 
          p 写真のアップロード
          v-radio-group(v-model="imageType")
            v-radio(v-for='n in imageTypeDef', :key='n.value', :label='n.name', :value='n.value')
          v-file-input(label='画像ファイル', v-model='imageFile')
        v-card-actions
          v-spacer
          v-btn(text, @click='dialogPicture = false') キャンセル
          v-btn(text, @click='uploadImage()') アップロード
</template>

<script>
import basic from '@/components/mixins/basic'
import { detect } from 'detect-browser';

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    items: { get() { return this.$store.state.Masters.Workers }} ,
    dateRangeText () { return this.dates.join(' ~ ') },
    workTypesWithDefault () {
      return [{ tenantWorkTypeId: null, name: '（グループデフォルト）' }, ...this.workTypes]
    }
  },
  data() {
    return {
      dates: [],
      datesmenu: false,
      users : [],
      imageTypeDef: [{name:'プロファイル', value:'Profile'}, {name:'その他画像１', value:'UserImage2'}, {name:'その他画像２',value:'UserImage3'}, {name:'その他画像３',value:'UserImage4'}],
      imageType: 'Profile',
      browser : null,
      dateStyle: 'picker',
      timeStyle: 'text',
      dialog: false,
      dialogMessage: '',
      dialogPicture: false,
      recordToUpload: null,
      dialogEdit: false,
      recordToEdit: {},
      imageFile: null,
      addingObject: {},
      roleDef: ['Admin', 'User'],
      addingDialog: false,
      changePasswordDialog: false,
      changePasswordObject: {},
      groups:[],
      tenantTeamMembers: [],
      workTypes: [],
      dayNames: ['日', '月', '火', '水', '木', '金', '土'],
      scheduleAM: [null, null, null, null, null, null, null],
      schedulePM: [null, null, null, null, null, null, null],
      passwordRules: [
        value => /[a-z]+/.test(value) || 'アルファベット小文字が１文字以上必要です。',
        value => /[A-Z]+/.test(value) || 'アルファベット大文字が１文字以上必要です。',
        value => /.{8,}/.test(value) || '8文字以上の文字が必要です',
        value => /[0-9]+/.test(value) || '数字が１文字以上必要です。'
      ],
      addFormValudated: false,
      changePasswordFormValudated: false,
      emailRules: [
        value => !!value || '必須項目です',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '有効なメールアドレスを入力してください'
        }
      ]
    }
  },
  mounted() {
    this.browser = detect()
    if (this.browser !== null) {
      if (this.browser.os.includes('iOS') || this.browser.os.includes('Android')) {
        this.dateStyle = 'input'
        this.timeStyle = 'time'
      }
    }
  },
  methods: {
    async masterReady () {
      if (!this.$store.getters['Login/isAdmin']) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/")
      }
      this.tenantTeamMembers = await this.$store.dispatch("Users/getTenantTeamsMembers")
      this.groups = await this.$store.dispatch("Calendar/getGroups", null)
      this.workTypes = await this.$store.dispatch("Calendar/getWorkTypes")
      await this.search()
    },
    async search () {
      this.users = await this.$store.dispatch("Users/getUsers");
    },
    async changePicture(item) {
      this.recordToUpload = item
      this.dialogPicture = true
      this.imageFile = null
    },
    async edit(item) {
      this.recordToEdit = JSON.parse(JSON.stringify(item))
      this.scheduleAM = [null, null, null, null, null, null, null]
      this.schedulePM = [null, null, null, null, null, null, null]
      if (item.userDetailId) {
        try {
          var schedules = await this.$store.dispatch("Calendar/getUserDefaultSchedules", item.userDetailId)
          if (schedules) {
            schedules.forEach(s => {
              if (s.dayOfWeek >= 0 && s.dayOfWeek <= 6) {
                this.scheduleAM[s.dayOfWeek] = s.tenantWorkTypeIdAM || null
                this.schedulePM[s.dayOfWeek] = s.tenantWorkTypeIdPM || null
              }
            })
            this.scheduleAM = [...this.scheduleAM]
            this.schedulePM = [...this.schedulePM]
          }
        } catch (e) { console.error('Failed to load schedules:', e) }
      }
      this.dialogEdit = true
    },
    async updateUser () {
      await this.$store.dispatch("Users/update", this.recordToEdit)
      if (this.recordToEdit.userDetailId) {
        for (var i = 0; i < 7; i++) {
          await this.$store.dispatch("Calendar/setUserDefaultSchedule", {
            userDetailId: this.recordToEdit.userDetailId,
            dayOfWeek: i,
            tenantWorkTypeIdAM: this.scheduleAM[i],
            tenantWorkTypeIdPM: this.schedulePM[i]
          })
        }
      }
      this.dialogEdit = false
      this.recordToEdit = {}
      this.search()
    },
    async uploadImage () {
      await this.$store.dispatch("Users/updateImage", {File: this.imageFile, AspNetId: this.recordToUpload.aspNetId, ImageType: this.imageType})
      this.dialogPicture = false
      this.imageFile = null
      this.search()
    },
    getImageUrl(item) {
      if (item.userImageId == null) { return this.site.deployFolder + '/noimage.png'}
      var result = this.$store.getters["Users/userImageUrl"] + item.userImageId
      return result
    },
    async addUser () {
      await this.$store.dispatch("Users/add", this.addingObject)
      this.addingDialog = false
      this.search()
    },
    prepareToAdd() {
      this.addingDialog = true
      this.addingObject = { email:'', password:'', role:'User'}
    },
    async changePassword () {
      var result = await this.$store.dispatch("Users/changePassword", this.changePasswordObject)
      if (result == true) {
        this.dispSuccess('パスワードを変更しました')
      }
      this.changePasswordDialog = false
      this.search()
    },
    prepareToChangePassword(item) {
      this.changePasswordDialog = true
      this.changePasswordObject = { aspNetId: item.aspNetId, newPassword:'', displayName: item.displayName }
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    }
  }
};
</script>

<style lang='scss'>
.user-table td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.user-image {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.5px;
  border-color: lightgray;
}
.schedule-select {
  max-width: 200px;
  font-size: 12px;
}
</style>